import { ref, onUnmounted } from "vue";

export function useAbortController() {
	const abortController = ref<AbortController | null>(null);

	const abortRequestAndResetController = () => {
		if (abortController.value) {
			abortController.value.abort();
		}
		abortController.value = new AbortController();
	};

	onUnmounted(() => {
		if (abortController.value) {
			abortController.value.abort();
		}
	});

	return {
		abortController,
		abortRequestAndResetController,
	};
}
